<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card>
              <v-card-title class="pb-5">
                <back-button></back-button>
                <v-spacer/>
                {{ $t($route.meta.title) }}
                <v-spacer/>
                <v-btn @click="update" :loading="loading"
                       class="btn-update">
                  <v-icon>mdi-update</v-icon>
                  بروز رسانی
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>


              <v-card-text>

                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <v-select
                        v-model="type"
                        :items="types"
                        :error-messages="errors.type"
                        item-text="title"
                        item-value="value"
                        label="نوع"
                        @change="fetchData"
                        outlined
                    ></v-select>
                  </v-flex>

                </v-row>


                <!--TYPE B2B-->

                <v-row v-if="type=='b2b'">
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <v-textarea
                        v-model="excelToken"
                        :error-messages="errors.key"
                        label="توکن اکسل"
                        required
                        outlined
                        dense
                    >
                    </v-textarea>
                  </v-flex>
                </v-row>


                <!--TYPE SLOT-->
                <v-row v-if="type=='slot'">
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <price-input :dense="true" :label="'قیمت'" v-model="price"></price-input>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="expire"
                        :error-messages="errors.expire"
                        label="انقضا(روز)"
                        required
                        type="number"
                        outlined
                        dense>
                    </v-text-field>
                  </v-flex>
                </v-row>


                <!--TYPE CHARGE-->

                <v-row v-if="type==='charge'">
                  <v-expansion-panels>
                    <v-expansion-panel
                        v-for="(item , i) in chargeData">

                      <v-expansion-panel-header>
                        <v-col>
                          <b>
                            <v-chip label color="accent" large>{{ lineType(i) }}</v-chip>
                          </b>
                        </v-col>

                      </v-expansion-panel-header>


                      <v-expansion-panel-content>

                        <v-card elevation="0" color="transparent" class="mb-4">

                          <v-card v-for="(value, key) in item" outlined class="mb-4">
<!--                            {{value}}-->
<!--                            {{key}}-{{value}}-->

                            <v-hover v-slot="{ hover }">
                              <v-card-title>
                                <v-chip outlined color="#009688">
                                  قیمت {{ key + 1 }}
                                </v-chip>

                                <v-spacer/>
                                <v-row align="center" class="ma-0 pt-3">
                                  <v-col cols="6" lg="6" class="pt-0">
                                    <v-text-field type="number" dense label="قیمت نمایشی" outlined
                                                  v-model="chargeData[i][key]['price']"/>
                                  </v-col>
                                  <v-col cols="6" lg="6" class="pt-0">
                                    <v-text-field type="number" dense label="قیمت اصلی" outlined
                                                  v-model="chargeData[i][key]['realPrice']"/>
                                  </v-col>

                                </v-row>
                              </v-card-title>
                            </v-hover>


                          </v-card>

                          <v-card-actions class="pa-0 my-4">
                            <v-btn block :loading="loading" large class="rounded-t-md rounded-b-lg"
                                   @click="newConfig(i)">
                              <v-icon>mdi-plus</v-icon>
                              افزودن قیمت
                            </v-btn>
                          </v-card-actions>

                          <v-divider/>
                        </v-card>

                      </v-expansion-panel-content>

                    </v-expansion-panel>
                  </v-expansion-panels>

                </v-row>


                <!--TYPE EWANO-->
                <v-row v-if="type==='ewano'">
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <v-row>
                      <v-text-field v-model="phone" outlined label="تلفن همراه"
                                    append-icon="mdi-phone"
                                    @keypress="isNumberKey"
                                    maxlength="11">
                      </v-text-field>
                      <v-btn :loading="loading" @click="sendCodeVerification()" class="btn-add-with-text"> ارسال کد</v-btn>
                    </v-row>

                  </v-flex>


                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2" v-if="sendCode">
                    <v-row>
                      <v-text-field v-model="verifyCode" outlined label="کد تایید را وارد کنید"
                                    append-icon="mdi-counter">
                      </v-text-field>
                    </v-row>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2" v-if="sendCode">
                    <v-row class="justify-content-center">
                      <v-btn style="width: 50% " :loading="loading" @click="submitCode()" class="btn-show ">تایید کد</v-btn>
                    </v-row>
                  </v-flex>



                </v-row>

              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>

</template>

<script>
export default {
  props: ['id'],
  data() {
    return {
      excelToken: null,
      key: '',
      verifyCode:null,
      sendCode: false,
      price: null,
      phone: null,
      expire: null,
      value: null,
      type: '',
      service: null,
      description: null,
      configsArray: [],
      picture: null,
      register: [],
      chargeData: {
        mci: [],
        mtn: [],
        rtl: [],
      },
      errors: {},
      loading: false,
      types: [
        {title: 'توکن اکسل', value: 'b2b'},
        {title: 'شارژ اوانو', value: 'charge'},
        {title: 'توکن اوانو', value: 'ewano'},
        {title: 'جایگاه سیم کارت', value: 'slot'},
      ],
    };
  },

  methods: {
    newConfig(input) {
      this.chargeData[input].push({
        price: 0,
        realPrice: 0,
      })
    },
    deleteConfig(x, i) {
      // if (this.value.length > 0) {
      //   this.value.pop()
      // }

      if (confirm("ویژگی حذف شود ؟")) {

        if (this.value[i].id) {
          this.value.splice(i, 1);
        }

      }
    },
    sendCodeVerification() {

      if (this.phone == null) {
        this.$toast.error('لطفا تلفن همراه را وارد کنید.');
      }

      this.loading = true
      this.requestApiPostًًRbًً(`admin/setting/ewano/phone`, {phone: this.phone}).then(({data}) => {
        this.sendCode = true
        this.loading = false;
        this.$toast.success('کد تایید برای شماره همراه شما ارسال شد.');
      }).catch(({response}) => {
        this.loading = false
        this.$toast.error(response.message);
      })
    },

    submitCode() {
      this.loading = true
      if (this.verifyCode == null) {
        this.$toast.error('لطفا کد تایید را وارد کنید.');
      }

      this.requestApiPostًًRbًً(`admin/setting/ewano/phone`, {phone: this.phone,code:this.verifyCode,_method:'PUT'}).then(({data}) => {
        this.phone=null
        this.verifyCode=null
        this.sendCode = false
        this.loading = false;
        this.$toast.success('تلفن همراه شما تایید شد.');
      }).catch(({response}) => {
        this.$toast.error(response.message);
        // this.$toast.error('خطا در تایید شماره همراه!');
        this.loading = false
      })
    },


    fetchData() {

      if (this.type === 'slot') {
        this.loading = true;
        this.requestApiGetRb(`admin/setting/slot`)
            .then(({data}) => {
              this.expire = data.data.expire;
              this.price = data.data.price
              this.loading = false;

            }).catch(({data}) => {
          this.loading = false
        })
      } else if (this.type === 'charge') {
        this.loading = true;
        this.requestApiGetRb(`admin/setting/charges`)
            .then(({data}) => {
              this.chargeData.mci = data.data.mci
              this.chargeData.mtn = data.data.mtn
              this.chargeData.rtl = data.data.rtl
              this.loading = false
            }).catch(({data}) => {
          this.loading = false
        })
      }


    },


    getConfig() {
      this.loading = true;
      this.requestApiGet(`config/${this.id}`).then(({data}) => {
        this.key = data.key;

        this.description = data.description;
        this.type = data.type
        this.service = data.service_id
        this.loading = false;

        if (this.type === 'array') {
          let txt = JSON.parse(data.val)
          this.value = txt;


        } else {
          this.value = data.val;
        }

      });
    },


    update() {
      this.loading = true
      if (this.type === 'b2b') {
        if (this.excelToken == null) {
          this.$toast.error('لطفا توکن را وارد کنید.');
        }
        this.requestApiPostًًRbًً(`admin/setting/b2b`, {cookie: this.excelToken, _method: 'PUT'}).then(({data}) => {
          this.loading = false;
          this.$toast.success('با موفقیت بروزرسانی شد');
        }).catch(({response}) => {
          this.loading = false
          // this.errors = response.data.errors;
        });
      } else if (this.type === 'slot') {
        this.requestApiPostًًRbًً(`admin/setting/slot`,
            {expire: this.expire, price: this.price.toString().replace(/,/g, ''), _method: 'PUT'}).then(({data}) => {
          this.loading = false;
          this.$toast.success('با موفقیت بروزرسانی شد');
        }).catch(({response}) => {
          this.loading = false
          // this.errors = response.data.errors;
        });
      } else if (this.type === 'charge') {
        this.requestApiPostًًRbًً(`admin/setting/charges`,
            {...this.chargeData, _method: 'PUT'}).then(({data}) => {
          this.loading = false;
          this.$toast.success('با موفقیت بروزرسانی شد');
        }).catch(({response}) => {
          this.loading = false
          // this.errors = response.data.errors;
        });
      }


    },


    updateConfig() {
      this.loading = true;
      let formData = new FormData();
      if (this.type === 'array') {
        formData.append('val', JSON.stringify(this.value))

      } else {
        formData.append('val', this.value)
      }

      //


      formData.append('service_id', this.service)
      formData.append('key', this.key)
      formData.append('type', this.type)
      formData.append('description', this.description)
      if (this.picture != null) formData.append('picture', this.picture);
      formData.append('_method', 'PUT')


      this.requestApiPost(`config/${this.id}`, formData
          , this.configurationFile()).then(({data}) => {
        this.loading = false;
        this.$toast.success('با موفقیت بروزرسانی شد');
        this.$router.push({name: 'configs'});
      }).catch(({response}) => {
        this.errors = response.data.errors;
      });
    },

    lineType(input) {
      if (input === 'mci') {
        return 'همراه اول'
      } else if (input === 'mtn') {
        return 'ایرانسل'
      } else if (input === 'rtl') {
        return 'رایتل'
      }
    },


    setEdited(x) {
      x.edited = true;
    },
    createRegister() {
      this.register.push({
        organName: '',
        type: null,
        date: '',
      })
    },


  },
  mounted() {
  },
};

</script>
